import { RankIntervalInputGq } from '../../graphql/projects/models/RankIntervalInputGq';

// Configuration for the rank intervals
// Change this to display a different interval
export const rankIntervals: RankIntervalInputGq[] = [
  { startRank: 1, endRank: 3 },
  { startRank: 4, endRank: 10 },
  { startRank: 11, endRank: 20 },
  { startRank: 21, endRank: 50 },
  { startRank: 51, endRank: 100 },
  { startRank: 101, endRank: null },
];

export const volumeIntervals = [
  { start: 0, end: 3999 },
  { start: 4000, end: 9999 },
  { start: 10000, end: 19999 },
  { start: 20000, end: null },
];

export const rankSegmentNames = ['1-3', '4-10', '11-20', '21-50', '51-100', '100+'];

export const volumeSegmentNames = ['20k+', '10k-19.9k', '4k - 9.9k', '0 - 3.9k'];

export const lineStandard = () => {
  return ['#353F4E', '#202630', '#788AA4', '#69938c', '#7da7a0', '#719c8b'];
};

export interface LegendIntervalsGq {
  readonly name?: string;
  readonly start?: number;
  readonly end?: number;
  readonly bgcolor: string;
  readonly color?: string;
}
